/**
 * A 401 and a 403 mean completely different things to a driver.
 *
 * 401: the access token expired. The account is fine and signing in again
 *      fixes it. This is the 24 hour logout, REL-361.
 * 403: the user has no company link. Signing in again changes nothing.
 *
 * Both used to collapse into one boolean, so both rendered "No company found"
 * and a customer screenshot could not tell us which had happened. Derive the
 * kind from the status the API attaches (see services/driverApi.ts) and from
 * nothing else. Sniffing the message text guesses, and it guessed wrong.
 */
export type AuthErrorKind = 'session-expired' | 'no-company';

export const authErrorKindFromError = (
  error: unknown
): AuthErrorKind | null => {
  const status = (error as { status?: number } | null | undefined)?.status;
  if (status === 401) return 'session-expired';
  if (status === 403) return 'no-company';
  return null;
};
